import React, { useState } from "react";
import AppContainer from "../../../components/AppContainer";
import { Grid, MenuItem, Stack, Typography } from "@mui/material";
import ImageUploader from "../../../components/ImageUploader";
import Label from "../../../components/Label";
import TextInput from "../../../components/TextInputs";
import globalStyle from "../../../globalStyle";
import { DatePicker } from "@mui/x-date-pickers";
import CustomDropDown from "../../../components/CutomDropDown";
import GlobalButton from "../../../components/CustomButton";
import CusomCheckBox from "../../../components/CustomCheckbox";
import { useDispatch, useSelector } from "react-redux";
import { setActiveTab } from "../../../lib/slices/activeTabSlice";

const AddEditAdmissionStep1 = () => {
  const dispatch = useDispatch();
  const [isReqHealthInfo, setIsReqHealthInfo] = useState(true);
  // Redux states
  const activeTab = useSelector((state) => state.activeTab.tabs);

  // Function

  const handleGotoNextStep = () => {
    dispatch(
      setActiveTab({
        ...activeTab,
        education_admission: "ed_add_admissions_step2",
      })
    );
  };

  return (
    <AppContainer
      primaryHeading={"Add New Admission"}
      secondaryHeading={"Step 1"}
    >
      <Typography mb={1} variant="h6" fontWeight={500}>
        Student Information
      </Typography>

      <ImageUploader />

      <Grid container my={2} spacing={2}>
        <Grid item xs={12} sm={3}>
          <Label labelText="First name" required htmlFor={"std_first_name"} />
          <TextInput
            id={"std_first_name"}
            required
            styleProps={globalStyle.textField}
            placeholder={"Enter first name"}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <Label labelText="Last name" required htmlFor={"std_last_name"} />
          <TextInput
            id={"std_last_name"}
            styleProps={globalStyle.textField}
            required
            placeholder={"Enter last name"}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <Label labelText="Birthday" required htmlFor={"std_birth_date"} />
          <DatePicker
            sx={{
              "&.MuiTextField-root": { width: "100% !important" },
              ...globalStyle.textField,
            }}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <Label labelText="Gender" required htmlFor={"std_gender"} />

          <CustomDropDown>
            <MenuItem>Male</MenuItem>
            <MenuItem>Female</MenuItem>
            <MenuItem>Other</MenuItem>
          </CustomDropDown>
        </Grid>
        <Grid item xs={12}>
          <Label
            labelText="First Address"
            required
            htmlFor={"std_first_address"}
          />
          <TextInput
            id={"std_first_address"}
            styleProps={globalStyle.textField}
            required
            placeholder={"Enter first address"}
          />
        </Grid>
        <Grid item xs={12}>
          <Label
            labelText="2nd Address"
            required
            htmlFor={"std_second_address"}
          />
          <TextInput
            id={"std_second_address"}
            styleProps={globalStyle.textField}
            required
            placeholder={"Enter first address"}
          />
        </Grid>
      </Grid>

      <Typography mb={1} variant="h6" fontWeight={500}>
        Contact Information
      </Typography>

      <Grid container my={1.5} spacing={2}>
        <Grid item xs={12} sm={4}>
          <Label
            labelText="Mobile number"
            required
            htmlFor={"std_mobile_number"}
          />
          <TextInput
            id={"std_mobile_number"}
            styleProps={globalStyle.textField}
            required
            placeholder={"Enter mobile number"}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Label labelText="Home number" required htmlFor={"std_home_number"} />
          <TextInput
            id={"std_home_number"}
            styleProps={globalStyle.textField}
            required
            placeholder={"Enter home number"}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Label
            labelText="Emial Address"
            required
            htmlFor={"std_email_number"}
          />
          <TextInput
            id={"std_email_number"}
            styleProps={globalStyle.textField}
            required
            placeholder={"Enter Email address"}
          />
        </Grid>
      </Grid>

      <Typography mb={1} variant="h6" fontWeight={500}>
        Parent/Guardian Information
      </Typography>

      <Grid container my={1.5} spacing={2}>
        <Grid item xs={12} sm={4}>
          <Label labelText="First name" required htmlFor={"gr_first_name"} />
          <TextInput
            id={"gr_first_name"}
            styleProps={globalStyle.textField}
            required
            placeholder={"Enter first name"}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Label labelText="Last name" required htmlFor={"gr_last_name"} />
          <TextInput
            id={"gr_last_name"}
            styleProps={globalStyle.textField}
            required
            placeholder={"Enter last name"}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Label
            labelText="Relation ship"
            required
            htmlFor={"gr_relation_ship"}
          />
          <CustomDropDown>
            <MenuItem value={"Mother"}>Mother</MenuItem>
            <MenuItem value={"Father"}>Father</MenuItem>
          </CustomDropDown>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Label
            labelText="Mobile number"
            required
            htmlFor={"gr_mobile_number"}
          />
          <TextInput
            id={"gr_mobile_number"}
            styleProps={globalStyle.textField}
            required
            placeholder={"Enter mobile number"}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Label labelText="CNIC/Other" required htmlFor={"gr_cnic_number"} />
          <TextInput
            id={"gr_cnic_number"}
            styleProps={globalStyle.textField}
            required
            placeholder={"Enter cnic number"}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Label
            labelText="Email Address"
            required
            htmlFor={"gr_emailaddress"}
          />
          <TextInput
            id={"gr_emailaddress"}
            styleProps={globalStyle.textField}
            required
            placeholder={"Enter email address"}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Label
            labelText="Relation ship to parent"
            required
            htmlFor={"gr_relation_ship"}
          />
          <CustomDropDown>
            <MenuItem value={"Son"}>Son</MenuItem>
            <MenuItem value={"Daughter"}>Daughter</MenuItem>
          </CustomDropDown>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Label
            labelText="Special education needed"
            required
            htmlFor={"gr_special_education"}
          />
          <CustomDropDown>
            <MenuItem value={"Yes"}>Yes</MenuItem>
            <MenuItem value={"Not"}>Not</MenuItem>
          </CustomDropDown>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Label
            labelText="If yes than give us reason"
            required
            htmlFor={"gr_reason"}
          />
          <TextInput
            id={"gr_reason"}
            styleProps={globalStyle.textField}
            required
            placeholder={"E.g; He is weak in math"}
          />
        </Grid>
      </Grid>

      <Stack direction={"row"} alignItems={"center"} gap={1}>
        <CusomCheckBox
          isChecked={isReqHealthInfo}
          handleChecked={() => {
            setIsReqHealthInfo((prev) => !prev);
          }}
        />
        <Typography variant="h6" fontWeight={500}>
          Health Information
        </Typography>
      </Stack>
      {isReqHealthInfo && (
        <Grid container my={1.5} spacing={2}>
          <Grid item xs={12} sm={4}>
            <Label labelText="Allergies" required htmlFor={"std_allergies"} />
            <CustomDropDown>
              <MenuItem value={"Yes"}>Yes</MenuItem>
              <MenuItem value={"No"}>No</MenuItem>
            </CustomDropDown>
          </Grid>

          <Grid item xs={12} sm={4}>
            <Label
              labelText="Health condition"
              required
              htmlFor={"std_health_condition"}
            />
            <CustomDropDown>
              <MenuItem value={"Good"}>Good</MenuItem>
              <MenuItem value={"Normal"}>Normal</MenuItem>
              <MenuItem value={"Sick"}>Sick</MenuItem>
            </CustomDropDown>
          </Grid>

          <Grid item xs={12} sm={4}>
            <Label labelText="Medication" required htmlFor={"std_medication"} />
            <CustomDropDown>
              <MenuItem value={"Yes"}>Yes</MenuItem>
              <MenuItem value={"No"}>No</MenuItem>
            </CustomDropDown>
          </Grid>

          <Grid item xs={12} sm={4}>
            <Label
              labelText="Emergency contact number"
              required
              htmlFor={"std_emergency_contact_number"}
            />
            <TextInput
              id={"std_emergency_contact_number"}
              styleProps={globalStyle.textField}
              required
              placeholder={"Enter contact number"}
            />
          </Grid>
        </Grid>
      )}

      {/* Next step button */}

      <Stack my={2} alignItems={"flex-end"}>
        <GlobalButton
          btnText={"Next"}
          handleClickBtn={handleGotoNextStep}
          styleProps={{
            height: 45,
            width: 120,
          }}
        />
      </Stack>
    </AppContainer>
  );
};

export default AddEditAdmissionStep1;
